import { toast, ToastOptions } from "react-toastify";
import { useCallback } from "react";
import "react-toastify/dist/ReactToastify.css";

interface ToasterReturn {
  showToast: (message: string, options?: ToastOptions) => void;
}

const Toaster = (): ToasterReturn => {
  const showToast = useCallback((message: string, options: ToastOptions = {}) => {
    toast(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      ...options,
    });
  }, []);

  return {
    showToast,
  };
};

export default Toaster;
